module.exports = __webpack_public_path__ + "static/bandfoto-gefaerbt3_hintergrund-6502a9eca50d90e7b30f1923f04c8bd3.jpg";